import { EntidadeBase } from 'hay-core-react';
class UsuarioTransacaoModel extends EntidadeBase {
    constructor() {
        super('usuariotransacao');
    }
}

const instance = new UsuarioTransacaoModel();
export default instance;
